/**
 * Countries data for DDI (international dialing code) selection
 * Feature: shared
 *
 * Country names are in Brazilian Portuguese for UI consistency.
 * Includes all UN-recognized countries plus common territories.
 * Sorted alphabetically by Portuguese name using locale-aware comparison.
 */

export interface Country {
  /** ISO 3166-1 alpha-2 country code */
  code: string;
  /** Country name in Brazilian Portuguese */
  name: string;
  /** International dialing code without "+" prefix */
  dialCode: string;
  /** Unicode emoji flag */
  flag: string;
}

export const BRAZIL: Country = {
  code: "BR",
  name: "Brasil",
  dialCode: "55",
  flag: "\u{1F1E7}\u{1F1F7}",
};

export const COUNTRIES: Country[] = [
  { code: "AF", name: "Afeganist\u00e3o", dialCode: "93", flag: "\u{1F1E6}\u{1F1EB}" },
  { code: "ZA", name: "\u00c1frica do Sul", dialCode: "27", flag: "\u{1F1FF}\u{1F1E6}" },
  { code: "AL", name: "Alb\u00e2nia", dialCode: "355", flag: "\u{1F1E6}\u{1F1F1}" },
  { code: "DE", name: "Alemanha", dialCode: "49", flag: "\u{1F1E9}\u{1F1EA}" },
  { code: "AD", name: "Andorra", dialCode: "376", flag: "\u{1F1E6}\u{1F1E9}" },
  { code: "AO", name: "Angola", dialCode: "244", flag: "\u{1F1E6}\u{1F1F4}" },
  { code: "AI", name: "Anguila", dialCode: "1264", flag: "\u{1F1E6}\u{1F1EE}" },
  { code: "AQ", name: "Ant\u00e1rtica", dialCode: "672", flag: "\u{1F1E6}\u{1F1F6}" },
  { code: "AG", name: "Ant\u00edgua e Barbuda", dialCode: "1268", flag: "\u{1F1E6}\u{1F1EC}" },
  { code: "SA", name: "Ar\u00e1bia Saudita", dialCode: "966", flag: "\u{1F1F8}\u{1F1E6}" },
  { code: "DZ", name: "Arg\u00e9lia", dialCode: "213", flag: "\u{1F1E9}\u{1F1FF}" },
  { code: "AR", name: "Argentina", dialCode: "54", flag: "\u{1F1E6}\u{1F1F7}" },
  { code: "AM", name: "Arm\u00eania", dialCode: "374", flag: "\u{1F1E6}\u{1F1F2}" },
  { code: "AW", name: "Aruba", dialCode: "297", flag: "\u{1F1E6}\u{1F1FC}" },
  { code: "AU", name: "Austr\u00e1lia", dialCode: "61", flag: "\u{1F1E6}\u{1F1FA}" },
  { code: "AT", name: "\u00c1ustria", dialCode: "43", flag: "\u{1F1E6}\u{1F1F9}" },
  { code: "AZ", name: "Azerbaij\u00e3o", dialCode: "994", flag: "\u{1F1E6}\u{1F1FF}" },
  { code: "BS", name: "Bahamas", dialCode: "1242", flag: "\u{1F1E7}\u{1F1F8}" },
  { code: "BH", name: "Bahrein", dialCode: "973", flag: "\u{1F1E7}\u{1F1ED}" },
  { code: "BD", name: "Bangladesh", dialCode: "880", flag: "\u{1F1E7}\u{1F1E9}" },
  { code: "BB", name: "Barbados", dialCode: "1246", flag: "\u{1F1E7}\u{1F1E7}" },
  { code: "BE", name: "B\u00e9lgica", dialCode: "32", flag: "\u{1F1E7}\u{1F1EA}" },
  { code: "BZ", name: "Belize", dialCode: "501", flag: "\u{1F1E7}\u{1F1FF}" },
  { code: "BJ", name: "Benin", dialCode: "229", flag: "\u{1F1E7}\u{1F1EF}" },
  { code: "BM", name: "Bermudas", dialCode: "1441", flag: "\u{1F1E7}\u{1F1F2}" },
  { code: "BY", name: "Bielorr\u00fassia", dialCode: "375", flag: "\u{1F1E7}\u{1F1FE}" },
  { code: "BO", name: "Bol\u00edvia", dialCode: "591", flag: "\u{1F1E7}\u{1F1F4}" },
  { code: "BQ", name: "Bonaire, Santo Eust\u00e1quio e Saba", dialCode: "599", flag: "\u{1F1E7}\u{1F1F6}" },
  { code: "BA", name: "B\u00f3snia e Herzegovina", dialCode: "387", flag: "\u{1F1E7}\u{1F1E6}" },
  { code: "BW", name: "Botsuana", dialCode: "267", flag: "\u{1F1E7}\u{1F1FC}" },
  { code: "BR", name: "Brasil", dialCode: "55", flag: "\u{1F1E7}\u{1F1F7}" },
  { code: "BN", name: "Brunei", dialCode: "673", flag: "\u{1F1E7}\u{1F1F3}" },
  { code: "BG", name: "Bulg\u00e1ria", dialCode: "359", flag: "\u{1F1E7}\u{1F1EC}" },
  { code: "BF", name: "Burkina Faso", dialCode: "226", flag: "\u{1F1E7}\u{1F1EB}" },
  { code: "BI", name: "Burundi", dialCode: "257", flag: "\u{1F1E7}\u{1F1EE}" },
  { code: "BT", name: "But\u00e3o", dialCode: "975", flag: "\u{1F1E7}\u{1F1F9}" },
  { code: "CV", name: "Cabo Verde", dialCode: "238", flag: "\u{1F1E8}\u{1F1FB}" },
  { code: "CM", name: "Camar\u00f5es", dialCode: "237", flag: "\u{1F1E8}\u{1F1F2}" },
  { code: "KH", name: "Camboja", dialCode: "855", flag: "\u{1F1F0}\u{1F1ED}" },
  { code: "CA", name: "Canad\u00e1", dialCode: "1", flag: "\u{1F1E8}\u{1F1E6}" },
  { code: "QA", name: "Catar", dialCode: "974", flag: "\u{1F1F6}\u{1F1E6}" },
  { code: "KZ", name: "Cazaquist\u00e3o", dialCode: "7", flag: "\u{1F1F0}\u{1F1FF}" },
  { code: "TD", name: "Chade", dialCode: "235", flag: "\u{1F1F9}\u{1F1E9}" },
  { code: "CL", name: "Chile", dialCode: "56", flag: "\u{1F1E8}\u{1F1F1}" },
  { code: "CN", name: "China", dialCode: "86", flag: "\u{1F1E8}\u{1F1F3}" },
  { code: "CY", name: "Chipre", dialCode: "357", flag: "\u{1F1E8}\u{1F1FE}" },
  { code: "CO", name: "Col\u00f4mbia", dialCode: "57", flag: "\u{1F1E8}\u{1F1F4}" },
  { code: "KM", name: "Comores", dialCode: "269", flag: "\u{1F1F0}\u{1F1F2}" },
  { code: "CG", name: "Congo", dialCode: "242", flag: "\u{1F1E8}\u{1F1EC}" },
  { code: "KP", name: "Coreia do Norte", dialCode: "850", flag: "\u{1F1F0}\u{1F1F5}" },
  { code: "KR", name: "Coreia do Sul", dialCode: "82", flag: "\u{1F1F0}\u{1F1F7}" },
  { code: "CI", name: "Costa do Marfim", dialCode: "225", flag: "\u{1F1E8}\u{1F1EE}" },
  { code: "CR", name: "Costa Rica", dialCode: "506", flag: "\u{1F1E8}\u{1F1F7}" },
  { code: "HR", name: "Cro\u00e1cia", dialCode: "385", flag: "\u{1F1ED}\u{1F1F7}" },
  { code: "CU", name: "Cuba", dialCode: "53", flag: "\u{1F1E8}\u{1F1FA}" },
  { code: "CW", name: "Cura\u00e7ao", dialCode: "599", flag: "\u{1F1E8}\u{1F1FC}" },
  { code: "DK", name: "Dinamarca", dialCode: "45", flag: "\u{1F1E9}\u{1F1F0}" },
  { code: "DJ", name: "Djibuti", dialCode: "253", flag: "\u{1F1E9}\u{1F1EF}" },
  { code: "DM", name: "Dominica", dialCode: "1767", flag: "\u{1F1E9}\u{1F1F2}" },
  { code: "EG", name: "Egito", dialCode: "20", flag: "\u{1F1EA}\u{1F1EC}" },
  { code: "SV", name: "El Salvador", dialCode: "503", flag: "\u{1F1F8}\u{1F1FB}" },
  { code: "AE", name: "Emirados \u00c1rabes Unidos", dialCode: "971", flag: "\u{1F1E6}\u{1F1EA}" },
  { code: "EC", name: "Equador", dialCode: "593", flag: "\u{1F1EA}\u{1F1E8}" },
  { code: "ER", name: "Eritreia", dialCode: "291", flag: "\u{1F1EA}\u{1F1F7}" },
  { code: "SK", name: "Eslov\u00e1quia", dialCode: "421", flag: "\u{1F1F8}\u{1F1F0}" },
  { code: "SI", name: "Eslov\u00eania", dialCode: "386", flag: "\u{1F1F8}\u{1F1EE}" },
  { code: "ES", name: "Espanha", dialCode: "34", flag: "\u{1F1EA}\u{1F1F8}" },
  { code: "US", name: "Estados Unidos", dialCode: "1", flag: "\u{1F1FA}\u{1F1F8}" },
  { code: "EE", name: "Est\u00f4nia", dialCode: "372", flag: "\u{1F1EA}\u{1F1EA}" },
  { code: "SZ", name: "Esu\u00e1tini", dialCode: "268", flag: "\u{1F1F8}\u{1F1FF}" },
  { code: "ET", name: "Eti\u00f3pia", dialCode: "251", flag: "\u{1F1EA}\u{1F1F9}" },
  { code: "FJ", name: "Fiji", dialCode: "679", flag: "\u{1F1EB}\u{1F1EF}" },
  { code: "PH", name: "Filipinas", dialCode: "63", flag: "\u{1F1F5}\u{1F1ED}" },
  { code: "FI", name: "Finl\u00e2ndia", dialCode: "358", flag: "\u{1F1EB}\u{1F1EE}" },
  { code: "FR", name: "Fran\u00e7a", dialCode: "33", flag: "\u{1F1EB}\u{1F1F7}" },
  { code: "GA", name: "Gab\u00e3o", dialCode: "241", flag: "\u{1F1EC}\u{1F1E6}" },
  { code: "GM", name: "G\u00e2mbia", dialCode: "220", flag: "\u{1F1EC}\u{1F1F2}" },
  { code: "GH", name: "Gana", dialCode: "233", flag: "\u{1F1EC}\u{1F1ED}" },
  { code: "GE", name: "Ge\u00f3rgia", dialCode: "995", flag: "\u{1F1EC}\u{1F1EA}" },
  { code: "GI", name: "Gibraltar", dialCode: "350", flag: "\u{1F1EC}\u{1F1EE}" },
  { code: "GD", name: "Granada", dialCode: "1473", flag: "\u{1F1EC}\u{1F1E9}" },
  { code: "GR", name: "Gr\u00e9cia", dialCode: "30", flag: "\u{1F1EC}\u{1F1F7}" },
  { code: "GL", name: "Groenl\u00e2ndia", dialCode: "299", flag: "\u{1F1EC}\u{1F1F1}" },
  { code: "GP", name: "Guadalupe", dialCode: "590", flag: "\u{1F1EC}\u{1F1F5}" },
  { code: "GU", name: "Guam", dialCode: "1671", flag: "\u{1F1EC}\u{1F1FA}" },
  { code: "GT", name: "Guatemala", dialCode: "502", flag: "\u{1F1EC}\u{1F1F9}" },
  { code: "GG", name: "Guernsey", dialCode: "44", flag: "\u{1F1EC}\u{1F1EC}" },
  { code: "GY", name: "Guiana", dialCode: "592", flag: "\u{1F1EC}\u{1F1FE}" },
  { code: "GF", name: "Guiana Francesa", dialCode: "594", flag: "\u{1F1EC}\u{1F1EB}" },
  { code: "GN", name: "Guin\u00e9", dialCode: "224", flag: "\u{1F1EC}\u{1F1F3}" },
  { code: "GQ", name: "Guin\u00e9 Equatorial", dialCode: "240", flag: "\u{1F1EC}\u{1F1F6}" },
  { code: "GW", name: "Guin\u00e9-Bissau", dialCode: "245", flag: "\u{1F1EC}\u{1F1FC}" },
  { code: "HT", name: "Haiti", dialCode: "509", flag: "\u{1F1ED}\u{1F1F9}" },
  { code: "HN", name: "Honduras", dialCode: "504", flag: "\u{1F1ED}\u{1F1F3}" },
  { code: "HK", name: "Hong Kong", dialCode: "852", flag: "\u{1F1ED}\u{1F1F0}" },
  { code: "HU", name: "Hungria", dialCode: "36", flag: "\u{1F1ED}\u{1F1FA}" },
  { code: "YE", name: "I\u00eamen", dialCode: "967", flag: "\u{1F1FE}\u{1F1EA}" },
  { code: "BV", name: "Ilha Bouvet", dialCode: "47", flag: "\u{1F1E7}\u{1F1FB}" },
  { code: "CX", name: "Ilha Christmas", dialCode: "61", flag: "\u{1F1E8}\u{1F1FD}" },
  { code: "IM", name: "Ilha de Man", dialCode: "44", flag: "\u{1F1EE}\u{1F1F2}" },
  { code: "NF", name: "Ilha Norfolk", dialCode: "672", flag: "\u{1F1F3}\u{1F1EB}" },
  { code: "AX", name: "Ilhas \u00c5land", dialCode: "358", flag: "\u{1F1E6}\u{1F1FD}" },
  { code: "KY", name: "Ilhas Caim\u00e3", dialCode: "1345", flag: "\u{1F1F0}\u{1F1FE}" },
  { code: "CC", name: "Ilhas Cocos (Keeling)", dialCode: "61", flag: "\u{1F1E8}\u{1F1E8}" },
  { code: "CK", name: "Ilhas Cook", dialCode: "682", flag: "\u{1F1E8}\u{1F1F0}" },
  { code: "FO", name: "Ilhas Faroe", dialCode: "298", flag: "\u{1F1EB}\u{1F1F4}" },
  { code: "GS", name: "Ilhas Ge\u00f3rgia do Sul e Sandwich do Sul", dialCode: "500", flag: "\u{1F1EC}\u{1F1F8}" },
  { code: "HM", name: "Ilhas Heard e McDonald", dialCode: "672", flag: "\u{1F1ED}\u{1F1F2}" },
  { code: "FK", name: "Ilhas Malvinas", dialCode: "500", flag: "\u{1F1EB}\u{1F1F0}" },
  { code: "MP", name: "Ilhas Marianas do Norte", dialCode: "1670", flag: "\u{1F1F2}\u{1F1F5}" },
  { code: "MH", name: "Ilhas Marshall", dialCode: "692", flag: "\u{1F1F2}\u{1F1ED}" },
  { code: "UM", name: "Ilhas Menores Distantes dos EUA", dialCode: "246", flag: "\u{1F1FA}\u{1F1F2}" },
  { code: "PN", name: "Ilhas Pitcairn", dialCode: "64", flag: "\u{1F1F5}\u{1F1F3}" },
  { code: "SB", name: "Ilhas Salom\u00e3o", dialCode: "677", flag: "\u{1F1F8}\u{1F1E7}" },
  { code: "TC", name: "Ilhas Turks e Caicos", dialCode: "1649", flag: "\u{1F1F9}\u{1F1E8}" },
  { code: "VI", name: "Ilhas Virgens Americanas", dialCode: "1340", flag: "\u{1F1FB}\u{1F1EE}" },
  { code: "VG", name: "Ilhas Virgens Brit\u00e2nicas", dialCode: "1284", flag: "\u{1F1FB}\u{1F1EC}" },
  { code: "IN", name: "\u00cdndia", dialCode: "91", flag: "\u{1F1EE}\u{1F1F3}" },
  { code: "ID", name: "Indon\u00e9sia", dialCode: "62", flag: "\u{1F1EE}\u{1F1E9}" },
  { code: "IR", name: "Ir\u00e3", dialCode: "98", flag: "\u{1F1EE}\u{1F1F7}" },
  { code: "IQ", name: "Iraque", dialCode: "964", flag: "\u{1F1EE}\u{1F1F6}" },
  { code: "IE", name: "Irlanda", dialCode: "353", flag: "\u{1F1EE}\u{1F1EA}" },
  { code: "IS", name: "Isl\u00e2ndia", dialCode: "354", flag: "\u{1F1EE}\u{1F1F8}" },
  { code: "IL", name: "Israel", dialCode: "972", flag: "\u{1F1EE}\u{1F1F1}" },
  { code: "IT", name: "It\u00e1lia", dialCode: "39", flag: "\u{1F1EE}\u{1F1F9}" },
  { code: "JM", name: "Jamaica", dialCode: "1876", flag: "\u{1F1EF}\u{1F1F2}" },
  { code: "JP", name: "Jap\u00e3o", dialCode: "81", flag: "\u{1F1EF}\u{1F1F5}" },
  { code: "JE", name: "Jersey", dialCode: "44", flag: "\u{1F1EF}\u{1F1EA}" },
  { code: "JO", name: "Jord\u00e2nia", dialCode: "962", flag: "\u{1F1EF}\u{1F1F4}" },
  { code: "KI", name: "Kiribati", dialCode: "686", flag: "\u{1F1F0}\u{1F1EE}" },
  { code: "KW", name: "Kuwait", dialCode: "965", flag: "\u{1F1F0}\u{1F1FC}" },
  { code: "LA", name: "Laos", dialCode: "856", flag: "\u{1F1F1}\u{1F1E6}" },
  { code: "LS", name: "Lesoto", dialCode: "266", flag: "\u{1F1F1}\u{1F1F8}" },
  { code: "LV", name: "Let\u00f4nia", dialCode: "371", flag: "\u{1F1F1}\u{1F1FB}" },
  { code: "LB", name: "L\u00edbano", dialCode: "961", flag: "\u{1F1F1}\u{1F1E7}" },
  { code: "LR", name: "Lib\u00e9ria", dialCode: "231", flag: "\u{1F1F1}\u{1F1F7}" },
  { code: "LY", name: "L\u00edbia", dialCode: "218", flag: "\u{1F1F1}\u{1F1FE}" },
  { code: "LI", name: "Liechtenstein", dialCode: "423", flag: "\u{1F1F1}\u{1F1EE}" },
  { code: "LT", name: "Litu\u00e2nia", dialCode: "370", flag: "\u{1F1F1}\u{1F1F9}" },
  { code: "LU", name: "Luxemburgo", dialCode: "352", flag: "\u{1F1F1}\u{1F1FA}" },
  { code: "MO", name: "Macau", dialCode: "853", flag: "\u{1F1F2}\u{1F1F4}" },
  { code: "MK", name: "Maced\u00f4nia do Norte", dialCode: "389", flag: "\u{1F1F2}\u{1F1F0}" },
  { code: "MG", name: "Madag\u00e1scar", dialCode: "261", flag: "\u{1F1F2}\u{1F1EC}" },
  { code: "MY", name: "Mal\u00e1sia", dialCode: "60", flag: "\u{1F1F2}\u{1F1FE}" },
  { code: "MW", name: "Malaui", dialCode: "265", flag: "\u{1F1F2}\u{1F1FC}" },
  { code: "MV", name: "Maldivas", dialCode: "960", flag: "\u{1F1F2}\u{1F1FB}" },
  { code: "ML", name: "Mali", dialCode: "223", flag: "\u{1F1F2}\u{1F1F1}" },
  { code: "MT", name: "Malta", dialCode: "356", flag: "\u{1F1F2}\u{1F1F9}" },
  { code: "MA", name: "Marrocos", dialCode: "212", flag: "\u{1F1F2}\u{1F1E6}" },
  { code: "MQ", name: "Martinica", dialCode: "596", flag: "\u{1F1F2}\u{1F1F6}" },
  { code: "MU", name: "Maur\u00edcio", dialCode: "230", flag: "\u{1F1F2}\u{1F1FA}" },
  { code: "MR", name: "Maurit\u00e2nia", dialCode: "222", flag: "\u{1F1F2}\u{1F1F7}" },
  { code: "YT", name: "Mayotte", dialCode: "262", flag: "\u{1F1FE}\u{1F1F9}" },
  { code: "MX", name: "M\u00e9xico", dialCode: "52", flag: "\u{1F1F2}\u{1F1FD}" },
  { code: "MM", name: "Mianmar", dialCode: "95", flag: "\u{1F1F2}\u{1F1F2}" },
  { code: "FM", name: "Micron\u00e9sia", dialCode: "691", flag: "\u{1F1EB}\u{1F1F2}" },
  { code: "MZ", name: "Mo\u00e7ambique", dialCode: "258", flag: "\u{1F1F2}\u{1F1FF}" },
  { code: "MD", name: "Mold\u00e1via", dialCode: "373", flag: "\u{1F1F2}\u{1F1E9}" },
  { code: "MC", name: "M\u00f4naco", dialCode: "377", flag: "\u{1F1F2}\u{1F1E8}" },
  { code: "MN", name: "Mong\u00f3lia", dialCode: "976", flag: "\u{1F1F2}\u{1F1F3}" },
  { code: "ME", name: "Montenegro", dialCode: "382", flag: "\u{1F1F2}\u{1F1EA}" },
  { code: "MS", name: "Montserrat", dialCode: "1664", flag: "\u{1F1F2}\u{1F1F8}" },
  { code: "NA", name: "Nam\u00edbia", dialCode: "264", flag: "\u{1F1F3}\u{1F1E6}" },
  { code: "NR", name: "Nauru", dialCode: "674", flag: "\u{1F1F3}\u{1F1F7}" },
  { code: "NP", name: "Nepal", dialCode: "977", flag: "\u{1F1F3}\u{1F1F5}" },
  { code: "NI", name: "Nicar\u00e1gua", dialCode: "505", flag: "\u{1F1F3}\u{1F1EE}" },
  { code: "NE", name: "N\u00edger", dialCode: "227", flag: "\u{1F1F3}\u{1F1EA}" },
  { code: "NG", name: "Nig\u00e9ria", dialCode: "234", flag: "\u{1F1F3}\u{1F1EC}" },
  { code: "NU", name: "Niue", dialCode: "683", flag: "\u{1F1F3}\u{1F1FA}" },
  { code: "NO", name: "Noruega", dialCode: "47", flag: "\u{1F1F3}\u{1F1F4}" },
  { code: "NC", name: "Nova Caled\u00f4nia", dialCode: "687", flag: "\u{1F1F3}\u{1F1E8}" },
  { code: "NZ", name: "Nova Zel\u00e2ndia", dialCode: "64", flag: "\u{1F1F3}\u{1F1FF}" },
  { code: "OM", name: "Om\u00e3", dialCode: "968", flag: "\u{1F1F4}\u{1F1F2}" },
  { code: "NL", name: "Pa\u00edses Baixos", dialCode: "31", flag: "\u{1F1F3}\u{1F1F1}" },
  { code: "PW", name: "Palau", dialCode: "680", flag: "\u{1F1F5}\u{1F1FC}" },
  { code: "PS", name: "Palestina", dialCode: "970", flag: "\u{1F1F5}\u{1F1F8}" },
  { code: "PA", name: "Panam\u00e1", dialCode: "507", flag: "\u{1F1F5}\u{1F1E6}" },
  { code: "PG", name: "Papua-Nova Guin\u00e9", dialCode: "675", flag: "\u{1F1F5}\u{1F1EC}" },
  { code: "PK", name: "Paquist\u00e3o", dialCode: "92", flag: "\u{1F1F5}\u{1F1F0}" },
  { code: "PY", name: "Paraguai", dialCode: "595", flag: "\u{1F1F5}\u{1F1FE}" },
  { code: "PE", name: "Peru", dialCode: "51", flag: "\u{1F1F5}\u{1F1EA}" },
  { code: "PF", name: "Polin\u00e9sia Francesa", dialCode: "689", flag: "\u{1F1F5}\u{1F1EB}" },
  { code: "PL", name: "Pol\u00f4nia", dialCode: "48", flag: "\u{1F1F5}\u{1F1F1}" },
  { code: "PR", name: "Porto Rico", dialCode: "1787", flag: "\u{1F1F5}\u{1F1F7}" },
  { code: "PT", name: "Portugal", dialCode: "351", flag: "\u{1F1F5}\u{1F1F9}" },
  { code: "KE", name: "Qu\u00eania", dialCode: "254", flag: "\u{1F1F0}\u{1F1EA}" },
  { code: "KG", name: "Quirguist\u00e3o", dialCode: "996", flag: "\u{1F1F0}\u{1F1EC}" },
  { code: "GB", name: "Reino Unido", dialCode: "44", flag: "\u{1F1EC}\u{1F1E7}" },
  { code: "CF", name: "Rep\u00fablica Centro-Africana", dialCode: "236", flag: "\u{1F1E8}\u{1F1EB}" },
  { code: "CD", name: "Rep\u00fablica Democr\u00e1tica do Congo", dialCode: "243", flag: "\u{1F1E8}\u{1F1E9}" },
  { code: "DO", name: "Rep\u00fablica Dominicana", dialCode: "1809", flag: "\u{1F1E9}\u{1F1F4}" },
  { code: "CZ", name: "Rep\u00fablica Tcheca", dialCode: "420", flag: "\u{1F1E8}\u{1F1FF}" },
  { code: "RE", name: "Reuni\u00e3o", dialCode: "262", flag: "\u{1F1F7}\u{1F1EA}" },
  { code: "RO", name: "Rom\u00eania", dialCode: "40", flag: "\u{1F1F7}\u{1F1F4}" },
  { code: "RW", name: "Ruanda", dialCode: "250", flag: "\u{1F1F7}\u{1F1FC}" },
  { code: "RU", name: "R\u00fassia", dialCode: "7", flag: "\u{1F1F7}\u{1F1FA}" },
  { code: "EH", name: "Saara Ocidental", dialCode: "212", flag: "\u{1F1EA}\u{1F1ED}" },
  { code: "WS", name: "Samoa", dialCode: "685", flag: "\u{1F1FC}\u{1F1F8}" },
  { code: "AS", name: "Samoa Americana", dialCode: "1684", flag: "\u{1F1E6}\u{1F1F8}" },
  { code: "SM", name: "San Marino", dialCode: "378", flag: "\u{1F1F8}\u{1F1F2}" },
  { code: "SH", name: "Santa Helena", dialCode: "290", flag: "\u{1F1F8}\u{1F1ED}" },
  { code: "LC", name: "Santa L\u00facia", dialCode: "1758", flag: "\u{1F1F1}\u{1F1E8}" },
  { code: "BL", name: "S\u00e3o Bartolomeu", dialCode: "590", flag: "\u{1F1E7}\u{1F1F1}" },
  { code: "KN", name: "S\u00e3o Crist\u00f3v\u00e3o e Nevis", dialCode: "1869", flag: "\u{1F1F0}\u{1F1F3}" },
  { code: "MF", name: "S\u00e3o Martinho (Fran\u00e7a)", dialCode: "590", flag: "\u{1F1F2}\u{1F1EB}" },
  { code: "PM", name: "S\u00e3o Pedro e Miquel\u00e3o", dialCode: "508", flag: "\u{1F1F5}\u{1F1F2}" },
  { code: "ST", name: "S\u00e3o Tom\u00e9 e Pr\u00edncipe", dialCode: "239", flag: "\u{1F1F8}\u{1F1F9}" },
  { code: "VC", name: "S\u00e3o Vicente e Granadinas", dialCode: "1784", flag: "\u{1F1FB}\u{1F1E8}" },
  { code: "SC", name: "Seicheles", dialCode: "248", flag: "\u{1F1F8}\u{1F1E8}" },
  { code: "SN", name: "Senegal", dialCode: "221", flag: "\u{1F1F8}\u{1F1F3}" },
  { code: "SL", name: "Serra Leoa", dialCode: "232", flag: "\u{1F1F8}\u{1F1F1}" },
  { code: "RS", name: "S\u00e9rvia", dialCode: "381", flag: "\u{1F1F7}\u{1F1F8}" },
  { code: "SG", name: "Singapura", dialCode: "65", flag: "\u{1F1F8}\u{1F1EC}" },
  { code: "SX", name: "Sint Maarten", dialCode: "1721", flag: "\u{1F1F8}\u{1F1FD}" },
  { code: "SY", name: "S\u00edria", dialCode: "963", flag: "\u{1F1F8}\u{1F1FE}" },
  { code: "SO", name: "Som\u00e1lia", dialCode: "252", flag: "\u{1F1F8}\u{1F1F4}" },
  { code: "LK", name: "Sri Lanka", dialCode: "94", flag: "\u{1F1F1}\u{1F1F0}" },
  { code: "SD", name: "Sud\u00e3o", dialCode: "249", flag: "\u{1F1F8}\u{1F1E9}" },
  { code: "SS", name: "Sud\u00e3o do Sul", dialCode: "211", flag: "\u{1F1F8}\u{1F1F8}" },
  { code: "SE", name: "Su\u00e9cia", dialCode: "46", flag: "\u{1F1F8}\u{1F1EA}" },
  { code: "CH", name: "Su\u00ed\u00e7a", dialCode: "41", flag: "\u{1F1E8}\u{1F1ED}" },
  { code: "SR", name: "Suriname", dialCode: "597", flag: "\u{1F1F8}\u{1F1F7}" },
  { code: "SJ", name: "Svalbard e Jan Mayen", dialCode: "47", flag: "\u{1F1F8}\u{1F1EF}" },
  { code: "TJ", name: "Tadjiquist\u00e3o", dialCode: "992", flag: "\u{1F1F9}\u{1F1EF}" },
  { code: "TH", name: "Tail\u00e2ndia", dialCode: "66", flag: "\u{1F1F9}\u{1F1ED}" },
  { code: "TW", name: "Taiwan", dialCode: "886", flag: "\u{1F1F9}\u{1F1FC}" },
  { code: "TZ", name: "Tanz\u00e2nia", dialCode: "255", flag: "\u{1F1F9}\u{1F1FF}" },
  { code: "IO", name: "Territ\u00f3rio Brit\u00e2nico do Oceano \u00cdndico", dialCode: "246", flag: "\u{1F1EE}\u{1F1F4}" },
  { code: "TF", name: "Terras Austrais e Ant\u00e1rticas Francesas", dialCode: "262", flag: "\u{1F1F9}\u{1F1EB}" },
  { code: "TL", name: "Timor-Leste", dialCode: "670", flag: "\u{1F1F9}\u{1F1F1}" },
  { code: "TG", name: "Togo", dialCode: "228", flag: "\u{1F1F9}\u{1F1EC}" },
  { code: "TK", name: "Tokelau", dialCode: "690", flag: "\u{1F1F9}\u{1F1F0}" },
  { code: "TO", name: "Tonga", dialCode: "676", flag: "\u{1F1F9}\u{1F1F4}" },
  { code: "TT", name: "Trinidad e Tobago", dialCode: "1868", flag: "\u{1F1F9}\u{1F1F9}" },
  { code: "TN", name: "Tun\u00edsia", dialCode: "216", flag: "\u{1F1F9}\u{1F1F3}" },
  { code: "TM", name: "Turcomenist\u00e3o", dialCode: "993", flag: "\u{1F1F9}\u{1F1F2}" },
  { code: "TR", name: "Turquia", dialCode: "90", flag: "\u{1F1F9}\u{1F1F7}" },
  { code: "TV", name: "Tuvalu", dialCode: "688", flag: "\u{1F1F9}\u{1F1FB}" },
  { code: "UA", name: "Ucr\u00e2nia", dialCode: "380", flag: "\u{1F1FA}\u{1F1E6}" },
  { code: "UG", name: "Uganda", dialCode: "256", flag: "\u{1F1FA}\u{1F1EC}" },
  { code: "UY", name: "Uruguai", dialCode: "598", flag: "\u{1F1FA}\u{1F1FE}" },
  { code: "UZ", name: "Uzbequist\u00e3o", dialCode: "998", flag: "\u{1F1FA}\u{1F1FF}" },
  { code: "VU", name: "Vanuatu", dialCode: "678", flag: "\u{1F1FB}\u{1F1FA}" },
  { code: "VA", name: "Vaticano", dialCode: "379", flag: "\u{1F1FB}\u{1F1E6}" },
  { code: "VE", name: "Venezuela", dialCode: "58", flag: "\u{1F1FB}\u{1F1EA}" },
  { code: "VN", name: "Vietn\u00e3", dialCode: "84", flag: "\u{1F1FB}\u{1F1F3}" },
  { code: "WF", name: "Wallis e Futuna", dialCode: "681", flag: "\u{1F1FC}\u{1F1EB}" },
  { code: "ZM", name: "Z\u00e2mbia", dialCode: "260", flag: "\u{1F1FF}\u{1F1F2}" },
  { code: "ZW", name: "Zimb\u00e1bue", dialCode: "263", flag: "\u{1F1FF}\u{1F1FC}" },
].sort((a, b) => a.name.localeCompare(b.name, "pt-BR"));

/**
 * Find a country by its dial code.
 * Note: Some dial codes are shared by multiple countries (e.g., "1" for US and Canada).
 * This function returns the first match found.
 */
export function findCountryByDialCode(dialCode: string): Country | undefined {
  return COUNTRIES.find((country) => country.dialCode === dialCode);
}

/**
 * Find a country by its ISO 3166-1 alpha-2 country code (e.g., "BR", "US").
 */
export function findCountryByCode(code: string): Country | undefined {
  return COUNTRIES.find((country) => country.code === code);
}
